import httpService from '../http/http.service';

interface BaseTransaction {
  acctNumber: string;
  purchaseDate: string;
  notificationURL: string;
  merchantName: string;
}

export interface OneTimeTransaction extends BaseTransaction {
  purchaseAmount: number;
  purchaseExponent: number;
  purchaseCurrency: string;
}

export interface RecurringTransaction extends BaseTransaction {
  recurringAmount: number;
  recurringExponent: number;
  recurringCurrency: string;
  recurringFrequency: number;
}

export type Transaction = OneTimeTransaction | RecurringTransaction;

export interface InitiateTransactionResponse {
    acsTransID: string;
    acsURL: string;
}

export interface GetTransactionStatusResponse {
  status: string;
}

const transactionService = {
  async initiateTransaction(transaction: Transaction): Promise<InitiateTransactionResponse> {
    return httpService.post('/areq', transaction);
  },
  async startChallengeRequest(url: string, transactionId: string): Promise<string> {
    const data = new URLSearchParams({
      acsTransID: transactionId,
    });

    return httpService.postForm(url, data);
  },
  async getTransactionStatus(id: string): Promise<GetTransactionStatusResponse> {
    return httpService.get(`/transaction/${id}/status`);
  }
};

export default transactionService;
